
const digest = 'c3ff329c5a9ff4625d81e5ed36db78f105753f854824fc2e15e9df8c0d69d078';
const classes = {"wrapper":"_wrapper_154vo_1","overLimit":"_overLimit_154vo_12"};
const css = `._wrapper_154vo_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  align-items: flex-end;
  font-size: 14px;
  flex: 1;
  flex-direction: column;
  margin: 7px 0;
  color: #909090;
}

._overLimit_154vo_12 {
  color: #d81616;
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  